<template>
  <div class="modal" v-bind:class="{ 'is-active': show }">
    <div class="modal-background"></div>
    <div class="modal-card consent-card">
      <section class="modal-card-body">
        <div class="consent-body">
          <div class="consent-icon-wrap">
            <span class="consent-icon">
              <i class="mdi mdi-shield-check-outline"></i>
            </span>
            <h1 class="title consent-title">Consentimiento informado</h1>
          </div>

          <div class="consent-block">
            <span style="white-space: pre-line">
              {{
                isBoss
                  ? consentimiento.lider.Lider
                  : consentimiento.colaboradores.Colaborador
              }}
            </span>
            <br />
            <h2 class="title is-7 consent-note">
              {{
                isBoss
                  ? consentimiento.lider.parrafo4
                  : consentimiento.colaboradores.parrafo4
              }}
            </h2>
          </div>

          <div class="consent-question">
            ¿Aceptas el consentimiento informado?
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button @click="endno()" class="button consent-btn-secondary">
          Rechazar
        </button>
        <button @click="next()" class="button consent-btn-primary">
          Aceptar y continuar
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import json from "../lideres/infoEncuesta.json";

export default {
  data() {
    return {
      consentimiento: json.consentimiento,
    };
  },
  props: {
    show: Boolean,
    isBoss: Boolean,
  },
  methods: {
    next() {
      this.$emit("aceptConsent", true);
    },
    endno() {
      this.$emit("endno");
    },
  },
};
</script>

<style scoped>
textarea {
  resize: none;
  overflow: hidden;
  box-shadow: inset 0 0px 0px rgb(10 10 10 / 10%);
}

.inputP {
  height: 50px !important;
  font-size: 40px !important;
  width: 100% !important;
  padding-left: 0px !important;
  box-shadow: inset 0 0px 0px rgb(10 10 10 / 10%) !important;
}

/* ── Contenedor del modal ─────────────────────────────────────────────── */
.consent-card {
  width: 680px;
  max-width: 92vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
}

.modal-card-body {
  flex: 1;
  overflow-y: auto;
  padding: 0;
}

/* ── Ícono + título ────────────────────────────────────────────────────── */
.consent-icon-wrap {
  text-align: center;
  padding: 1.75rem 1.75rem 0.5rem;
}

.consent-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(94, 44, 165, 0.1);
  margin-bottom: 0.9rem;
}

.consent-icon i {
  font-size: 22px;
  color: #5e2ca5;
}

.consent-title {
  font-size: 1.15rem !important;
  font-weight: 500;
  margin: 0 !important;
  color: #363636;
}

/* ── Bloque de texto legal ─────────────────────────────────────────────── */
.consent-body {
  padding: 0 1.75rem 1.25rem;
}

.consent-block {
  background: #f5f5f5;
  border-radius: 10px;
  padding: 1.1rem 1.25rem;
  margin-top: 1.25rem;
}

.consent-block span {
  font-size: 0.9rem;
  line-height: 1.7;
  color: #555;
}

.consent-note {
  font-size: 0.78rem !important;
  line-height: 1.6;
  color: #888 !important;
  margin-top: 0.6rem !important;
}

/* ── Pregunta de consentimiento ────────────────────────────────────────── */
.consent-question {
  margin-top: 1.25rem;
  padding: 0.85rem 1rem;
  border-radius: 10px;
  background: #f5f5f5;
  font-size: 0.9rem;
  font-weight: 500;
  color: #363636;
  text-align: center;
}

/* ── Footer / botones ──────────────────────────────────────────────────── */
.modal-card-foot {
  border: none;
  border-top: 1px solid #eee;
  background: #fff;
  padding: 1.25rem 1.75rem;
  display: flex;
  gap: 10px;
}

.consent-btn-primary {
  flex: 1;
  background: #5e2ca5 !important;
  color: #fff !important;
  border: none !important;
  border-radius: 10px !important;
  font-weight: 500;
}

.consent-btn-secondary {
  flex: 1;
  background: #f5f5f5 !important;
  color: #555 !important;
  border: 1px solid #e5e5e5 !important;
  border-radius: 10px !important;
}

/* ── Mobile: pantalla completa ─────────────────────────────────────────── */
@media screen and (max-width: 768px) {
  .consent-card {
    width: 100vw !important;
    max-width: 100vw;
    height: 100vh !important;
    max-height: 100vh;
    margin: 0;
    border-radius: 0;
  }

  .consent-icon-wrap {
    padding: 1.5rem 1.25rem 0.4rem;
  }

  .consent-title {
    font-size: 1.05rem !important;
  }

  .consent-body {
    padding: 0 1.25rem 1rem;
  }

  .modal-card-foot {
    flex-wrap: wrap;
    padding: 1rem 1.25rem;
  }

  .modal-card-foot .button {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/ModalConsentimiento.vue